import { CommonContentContext } from '@/utils/context/commonContent/CommonContentContext';
import { useMsal } from '@azure/msal-react';
import { useContext, useEffect, useState } from 'react';
import { MenuIcon } from '../icons';
import { getBreakpoint, getScreenWidth } from '@/utils/navbar';
import { UserSelectTenant } from '../multiple-tenant/UserSelectTenant';
import { GoBackButton } from './GoBackButton';

export const Header = ({ setIsSelectedTenant }) => {
  const { accounts } = useMsal();
  const { showMenu, setShowMenu, setNavbarWithMenu, backButtonConfig } = useContext(CommonContentContext);
  const [breakpoint, setBreakpoint] = useState<string | undefined>(getBreakpoint());

  const handleBreakpoint = () => {
    const minWidthBreakpoint = 1579;
    const currentWidth = getScreenWidth();
    setBreakpoint(currentWidth);
    if (Number(currentWidth) < minWidthBreakpoint) {
      setShowMenu(true);
    } else {
      setShowMenu(false);
      setNavbarWithMenu(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleBreakpoint);

    return () => {
      window.removeEventListener('resize', handleBreakpoint);
    };
  }, [breakpoint]);

  useEffect(() => {
    handleBreakpoint();
    window.addEventListener('resize', handleBreakpoint);

    return () => {
      window.removeEventListener('resize', handleBreakpoint);
    };
  }, []);

  return (
    <div id="header" className="flex pl-[20px] pr-[5px] pt-[15px] min-[425px]:pr-[0px]">
      <div className="flex w-full items-center gap-4">
        <div className={`${!showMenu && 'hidden'} p-2`} data-cy="menu-icon">
          <button
            id="menu-button"
            className="rounded border-[3px] border-primary"
            onClick={() => setNavbarWithMenu(true)}
          >
            <MenuIcon className={'fill-primary'} />
          </button>
        </div>

        {backButtonConfig.show && (
          <div className="h-[44px]">
            <GoBackButton />
          </div>
        )}
      </div>

      <div className="flex w-full justify-end pl-[0px] pr-[0px] min-[425px]:pl-5 min-[425px]:pr-5">
        <div className="flex items-center">
          <div className="flex w-full gap-[25px]">
            <div>
              <UserSelectTenant accounts={accounts} setIsSelectedTenant={setIsSelectedTenant} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
